import {
  normalizeTokenName,
  TOKEN_NAME_TO_CANONICAL,
  type CanonicalToken,
} from '../localized-defaults';
import { TEMPLATE_TOKEN_PATTERN } from './message-builder';

/** Every token the body uses, by canonical name or any language's alias, as substitution does. */
export function templateTokens(
  body: string | null | undefined,
): Set<CanonicalToken> {
  const tokens = new Set<CanonicalToken>();
  if (!body) return tokens;
  const pattern = new RegExp(TEMPLATE_TOKEN_PATTERN.source, 'g');
  let match = pattern.exec(body);
  while (match) {
    const token = TOKEN_NAME_TO_CANONICAL.get(normalizeTokenName(match[1]));
    if (token) tokens.add(token);
    match = pattern.exec(body);
  }
  return tokens;
}

export function templateUsesToken(
  body: string | null | undefined,
  canonicalToken: CanonicalToken,
): boolean {
  return templateTokens(body).has(canonicalToken);
}
